import { getProjectForCrmDeal } from '../../api-v2/queries/board-queries';

export function crmProjectPageLoader(queryClient) {
  return (opts) => {
    const url = new URL(opts.request.url);
    // It must have two underscores in the parameter name
    let crmDealId = url.searchParams.get('crm__id');

    // If crm__id is missing, try to use id as an alternative because with Microsoft Dynamics CRM it is in the "id" param
    if (!crmDealId) {
      crmDealId = url.searchParams.get('id');
    }

    queryClient.ensureQueryData(getProjectForCrmDeal({ crmDealId }));

    return { crmDealId };
  };
}
